module.exports = __webpack_public_path__ + "img/ykyl.9804210e.png";